(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9121],{

/***/ 10836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ cabins_decks; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/components/sections/head-tags/head-tags.tsx + 5 modules
var head_tags = __webpack_require__(92848);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(21214);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion_Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(61250);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/accordionSummaryClasses.js
var accordionSummaryClasses = __webpack_require__(82285);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(2373);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./public/static/icons/arrowUpV2.svg
var arrowUpV2 = __webpack_require__(50409);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/accordion/accordion.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Accordion = function Accordion(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion_Accordion/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
    sx: (0,defineProperty/* default */.Z)({
      padding: '0',
      borderRadius: '6px',
      marginBottom: '16px',
      boxShadow: '0 6px 8px rgba(0,0,0,.02)'
    }, "&:before", {
      display: 'none'
    })
  }));
};
var AccordionHead = function AccordionHead(props) {
  var _ref2;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSummary/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
    expandIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
      inheritViewBox: true,
      component: arrowUpV2/* default */.Z,
      sx: {
        transform: 'rotate(180deg)',
        color: global_style/* colorsUnifications.azure.100 */.Vg.azure[100]
      }
    }),
    sx: (_ref2 = {}, (0,defineProperty/* default */.Z)(_ref2, ".".concat(accordionSummaryClasses/* default.content */.Z.content), (0,defineProperty/* default */.Z)({
      display: 'flex',
      flexDirection: 'column',
      margin: 0
    }, "&.".concat(accordionSummaryClasses/* default.expanded */.Z.expanded), {
      margin: 0
    })), (0,defineProperty/* default */.Z)(_ref2, "padding", '24px'), _ref2)
  }));
};
var AccordionCollapseContent = function AccordionCollapseContent(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionDetails/* default */.Z, _objectSpread(_objectSpread({}, props), {}, {
    sx: {
      padding: '16px 24px'
    }
  }));
};
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./src/components/atoms/static-pill/static-pill.tsx
var static_pill = __webpack_require__(49451);
// EXTERNAL MODULE: ./src/utils/object-keys.ts
var object_keys = __webpack_require__(43711);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
;// CONCATENATED MODULE: ./src/components/sections/cabin-type/cabin-type.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledCabinTypeSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1lbu5p15"
} : 0)("color:", function (props) {
  return props.theme.colorsUnifications.gunmetal['100'];
}, ";font-size:14px;line-height:24px;margin-bottom:36px;h1{font-size:", function (props) {
  return props.theme.fontSize.headlineXXL;
}, ";line-height:1.2;margin-bottom:16px;margin-top:36px;}h3{font-size:24px;margin-top:36px;margin-bottom:30px;}h1,h3{@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{margin-top:80px;}}" + ( true ? "" : 0));
var StyledCabinTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1lbu5p14"
} : 0)("font-size:16px;font-weight:700;margin-bottom:16px;color:", function (props) {
  return props.theme.colorsUnifications.gunmetal['100'];
}, ";" + ( true ? "" : 0));
var StyledSubCabinContentHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lbu5p13"
} : 0)( true ? {
  name: "1nttra6",
  styles: "font-weight:700;line-height:24px"
} : 0);
var StyledSubCabinContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lbu5p12"
} : 0)( true ? {
  name: "1fgdcyd",
  styles: "margin-bottom:24px"
} : 0);
var StyledSubCabinContentItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1lbu5p11"
} : 0)("position:relative;font-size:", function (props) {
  return props.theme.fontSize.regularS;
}, ";line-height:", function (props) {
  return props.theme.lineHeight.headlineL;
}, ";margin:8px 0;padding-left:28px;&:before{content:'';position:absolute;top:50%;left:0;width:14px;height:14px;margin-top:-7px;border:4px solid ", function (props) {
  return props.theme.colorsUnifications.azure['20'];
}, ";background-color:", function (props) {
  return props.theme.colorsUnifications.azure['100'];
}, ";border-radius:100%;}" + ( true ? "" : 0));
var StyledCabinAmenitiesContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lbu5p10"
} : 0)( true ? {
  name: "idfvfs",
  styles: "display:flex;justify-content:flex-start"
} : 0);
// EXTERNAL MODULE: ./public/static/icons/adults.svg
var adults = __webpack_require__(89188);
;// CONCATENATED MODULE: ./public/static/icons/area.svg
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#area_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M15.781 13.635a.751.751 0 0 0 0-1.062l-2.134-2.135a.762.762 0 0 0-1.083 0 .75.75 0 0 0 .01 1.05l.867.867h-8.21a1.585 1.585 0 0 1-1.586-1.586V2.56l.867.867a.75.75 0 1 0 1.06-1.06L3.424.219a.747.747 0 0 0-1.056 0L.219 2.366a.75.75 0 0 0-.01 1.05.765.765 0 0 0 1.082 0l.854-.857v8.21a3.085 3.085 0 0 0 3.085 3.085h8.211l-.867.867a.75.75 0 1 0 1.06 1.06l2.147-2.146ZM15.252 9.406a.75.75 0 0 0 .75-.75V3.084A3.09 3.09 0 0 0 12.917 0H7.344a.75.75 0 1 0 0 1.5h5.573a1.587 1.587 0 0 1 1.585 1.585v5.571a.75.75 0 0 0 .75.75Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M9.973 9.885a.56.56 0 0 0 .56-.56V7.008A1.76 1.76 0 0 0 7.57 5.722a1.757 1.757 0 0 0-1.938-.313.56.56 0 0 0-1.025.313v3.603a.56.56 0 1 0 1.121 0V7.008a.641.641 0 1 1 1.281 0v2.317a.56.56 0 0 0 1.121 0V7.008a.641.641 0 1 1 1.281 0v2.317a.56.56 0 0 0 .562.56Z",
    fill: "#1A181E",
    fillOpacity: 0.7
  }), /*#__PURE__*/react.createElement("path", {
    d: "M13.169 5.967h-.433l.507-.508c.235-.23.374-.542.39-.871v-.06a1.355 1.355 0 0 0-2.69-.215.528.528 0 0 0 1.043.167.298.298 0 0 1 .594.048v.014a.264.264 0 0 1-.082.17L11.089 6.12a.528.528 0 0 0 .373.901h1.707a.528.528 0 0 0 0-1.056Z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "area_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

/* harmony default export */ var icons_area = (SvgArea);
;// CONCATENATED MODULE: ./public/static/icons/stack.svg
var _path;

function stack_extends() { stack_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return stack_extends.apply(this, arguments); }



var SvgStack = function SvgStack(props) {
  return /*#__PURE__*/react.createElement("svg", stack_extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.015.236a2.3 2.3 0 0 0-2.03 0L.62 3.37a1.106 1.106 0 0 0 0 1.987l6.365 3.134a2.3 2.3 0 0 0 2.03 0l6.365-3.134a1.106 1.106 0 0 0 0-1.987L9.015.236ZM.657 6.988c.101-.05.22-.05.321 0l6.007 2.958a2.3 2.3 0 0 0 2.03 0l6.007-2.958c.101-.05.22-.05.321 0l.037.018c.827.407.827 1.58 0 1.988l-6.365 3.134c-.64.314-1.39.314-2.03 0L.62 8.994a1.106 1.106 0 0 1 0-1.988l.037-.018Zm.321 3.637a.363.363 0 0 0-.321 0l-.037.018a1.106 1.106 0 0 0 0 1.987l6.365 3.134a2.3 2.3 0 0 0 2.03 0l6.365-3.134a1.106 1.106 0 0 0 0-1.988l-.037-.017a.363.363 0 0 0-.321 0l-6.007 2.957a2.3 2.3 0 0 1-2.03 0L.978 10.625Z"
  })));
};

/* harmony default export */ var stack = (SvgStack);
;// CONCATENATED MODULE: ./src/components/sections/cabin-type/cabin-type.tsx




function cabin_type_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var StyledStaticPill = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(static_pill/* StaticPill */.J,  true ? {
  target: "e1kqa5w80"
} : 0)( true ? {
  name: "sd72ql",
  styles: "border:2px solid #f0f0f0;border-radius:32px;box-shadow:0px 6px 8px rgba(0, 0, 0, 0.02);cursor:pointer"
} : 0);

var CabinInfoIcon = function CabinInfoIcon(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
    component: 'span',
    sx: {
      display: 'flex',
      alignItems: 'center'
    },
    color: global_style/* colorsUnifications.gunmetal.100 */.Vg.gunmetal[100],
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
      inheritViewBox: true,
      style: {
        color: global_style/* colorsUnifications.gunmetal.70 */.Vg.gunmetal[70],
        fontSize: 16,
        marginRight: '8px'
      },
      component: props.icon
    }), props.text]
  });
};

var CabinTypeDetails = function CabinTypeDetails(_ref) {
  var _cabin$image;

  var cabin = _ref.cabin,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion, {
    expanded: expanded,
    onChange: onToggle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AccordionHead, {
      id: cabin.title,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCabinTitle, {
        children: cabin.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        component: 'p',
        sx: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '24px',
          margin: '0'
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinInfoIcon, {
          icon: icons_area,
          text: cabin.size
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinInfoIcon, {
          icon: adults/* default */.Z,
          text: "max. ".concat(cabin.maxPassengers)
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinInfoIcon, {
          icon: stack,
          text: cabin.location
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionCollapseContent, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
        container: true,
        spacing: 2,
        sx: function sx(theme) {
          return (0,defineProperty/* default */.Z)({}, theme.breakpoints.down('md'), {
            flexDirection: 'column-reverse'
          });
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 8,
          children: [cabin.amenities.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubCabinContentHeading, {
              children: (0,translation_service.__)('cabinAmenities')
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubCabinContent, {
              children: cabin.amenities.map(function (item, index) {
                return item ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubCabinContentItem, {
                  children: item
                }, "cabin-amenities".concat(index)) : null;
              })
            })]
          }), cabin.advantages.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubCabinContentHeading, {
              children: (0,translation_service.__)('cabinAdvantages')
            }), cabin.advantages.map(function (item, index) {
              return item ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubCabinContentItem, {
                children: item
              }, "cabin-advantages".concat(index)) : null;
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
          item: true,
          xs: 12,
          md: 4,
          children: (cabin === null || cabin === void 0 ? void 0 : (_cabin$image = cabin.image) === null || _cabin$image === void 0 ? void 0 : _cabin$image.original) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
            component: 'img',
            sx: {
              borderRadius: '6px',
              maxWidth: '100%'
            },
            src: cabin.image.original,
            alt: cabin.title
          })
        })]
      })
    })]
  });
};
var CABIN_TYPES_ORDER = ['inside', 'outside', 'balcony', 'suite'];
var CabinType = function CabinType(props) {
  var _cabinTypesComps$;

  var cabinTypesComps = (0,object_keys/* objectKeys */.Y)(props.cabinTypes).sort(function (a, b) {
    return CABIN_TYPES_ORDER.indexOf(a) - CABIN_TYPES_ORDER.indexOf(b);
  });

  var _React$useState = react.useState((_cabinTypesComps$ = cabinTypesComps[0]) !== null && _cabinTypesComps$ !== void 0 ? _cabinTypesComps$ : ''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      activeCabinType = _React$useState2[0],
      setActiveCabinType = _React$useState2[1];

  var _React$useState3 = react.useState(''),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      expandedCabinTitle = _React$useState4[0],
      setExpandedCabinTitle = _React$useState4[1];

  var decksByCabinType = react.useMemo(function () {
    return props.decks.reduce(function (acc, deck) {
      var _deck$cabins;

      (_deck$cabins = deck.cabins) === null || _deck$cabins === void 0 ? void 0 : _deck$cabins.forEach(function (cabin) {
        if (!acc[cabin.kind]) {
          acc[cabin.kind] = [];
        }

        var isCabinTypeAlreadyAdded = acc[cabin.kind].some(function (el) {
          return el.externalCode === cabin.externalCode;
        });

        if (isCabinTypeAlreadyAdded) {
          return;
        }

        acc[cabin.kind].push(cabin);
      });
      return acc;
    }, {});
  }, props.decks);

  var handleCabinExpand = function handleCabinExpand(cabinTitle) {
    if (expandedCabinTitle === cabinTitle) {
      setExpandedCabinTitle('');
    } else {
      setExpandedCabinTitle(cabinTitle);
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCabinTypeSection, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        children: props.headline
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        children: props.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
        children: [" ", (0,translation_service.__)('cabins'), " "]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        sx: {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '8px',
          marginBottom: '36px'
        },
        children: cabinTypesComps.map(function (type) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledStaticPill, {
            type: activeCabinType === type ? 'primary' : undefined,
            onClick: function onClick() {
              return setActiveCabinType(type);
            },
            children: (0,translation_service.__)(type)
          }, type);
        })
      }), (decksByCabinType[activeCabinType] || []).map(function (cabin) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinTypeDetails, {
          cabin: cabin,
          expanded: expandedCabinTitle === cabin.title,
          onToggle: function onToggle() {
            return handleCabinExpand(cabin.title);
          }
        }, cabin.title);
      })]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/sections/deck-plan/deck-plan.style.tsx

var StyledHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1lysu2x1"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";" + ( true ? "" : 0));
var StyledDeckPlanContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1lysu2x0"
} : 0)("color:", function (props) {
  return props.theme.colorsUnifications.gunmetal['100'];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js
var react_content_loader_es = __webpack_require__(24561);
// EXTERNAL MODULE: ./src/utils/buildVersion.ts
var buildVersion = __webpack_require__(76577);
// EXTERNAL MODULE: ./src/components/atoms/image/image.tsx + 2 modules
var image_image = __webpack_require__(87647);
;// CONCATENATED MODULE: ./src/components/sections/deck-plan/deck-plan.tsx




function deck_plan_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function deck_plan_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? deck_plan_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : deck_plan_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function deck_plan_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var deck_plan_StyledStaticPill = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(static_pill/* StaticPill */.J,  true ? {
  target: "ecokvi0"
} : 0)( true ? {
  name: "sd72ql",
  styles: "border:2px solid #f0f0f0;border-radius:32px;box-shadow:0px 6px 8px rgba(0, 0, 0, 0.02);cursor:pointer"
} : 0);

var ImageLoader = function ImageLoader(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react_content_loader_es/* default */.ZP, deck_plan_objectSpread(deck_plan_objectSpread({
    viewBox: "0 0 500 350",
    width: '100%',
    height: 300,
    backgroundColor: "#fff",
    foregroundColor: "#f3f3f3",
    id: "deck-plan-loader"
  }, props), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M484.52,64.61H15.65C7.1,64.61.17,71.2.17,79.31V299.82c0,8.12,6.93,14.7,15.48,14.7H484.52c8.55,0,15.48-6.58,15.48-14.7V79.31C500,71.2,493.07,64.61,484.52,64.61Zm-9,204.34c0,11.84-7.14,21.44-15.94,21.44H436.39L359.16,171.52c-7.1-10.92-19.67-11.16-27-.51L258.64,277.94C253.78,285,245.73,286,240,280.2l-79.75-80.62c-6-6.06-14.33-5.7-20,.88L62.34,290.39H40.63c-8.8,0-15.94-9.6-15.94-21.44V110.19c0-11.84,7.14-21.44,15.94-21.44H459.54c8.8,0,15.94,9.6,15.94,21.44Z"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
      cx: "120",
      cy: "140",
      rx: "28",
      ry: "28"
    })]
  }));
};

var DeckPlan = function DeckPlan(props) {
  var _selectedDeckData$ver;

  var _React$useState = react.useState(true),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isLoadingImage = _React$useState2[0],
      setIsLoadingImage = _React$useState2[1];

  var theme = (0,useTheme/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
  var deckNumbersMap = props.decks.reduce(function (acc, deck) {
    acc[deck.number] = deck;
    return acc;
  }, {});
  var deckNumbers = Object.keys(deckNumbersMap).sort(function (a, b) {
    return Number(a) - Number(b);
  });
  var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
  var cabinFallbackBackground = "".concat(assetPrefix, "/static/images/no-deckplan-available.png");

  var _React$useState3 = react.useState(deckNumbers[0] || ''),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      selectedDeckNumber = _React$useState4[0],
      setSelectedDeckNumber = _React$useState4[1];

  react.useEffect(function () {
    setIsLoadingImage(true);
  }, [selectedDeckNumber]);
  var selectedDeckData = deckNumbersMap[selectedDeckNumber] || {};
  var mobileDeckImage = (_selectedDeckData$ver = selectedDeckData.verticalDeckPlan) !== null && _selectedDeckData$ver !== void 0 && _selectedDeckData$ver.url ? selectedDeckData.verticalDeckPlan : null;
  var deckImage = isMobile ? mobileDeckImage : selectedDeckData.deckPlan;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledDeckPlanContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeading, {
        children: props.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        sx: {
          display: 'flex',
          gap: '8px',
          flexWrap: 'wrap',
          marginBottom: '36px'
        },
        children: deckNumbers.map(function (deckNumber) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(deck_plan_StyledStaticPill, {
            onClick: function onClick() {
              return setSelectedDeckNumber(deckNumber);
            },
            type: selectedDeckNumber === deckNumber ? 'primary' : undefined,
            children: deckNumbersMap[deckNumber].title
          }, deckNumber);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
        sx: {
          marginTop: '36px',
          marginBottom: '36px',
          textAlign: 'center',
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '6px'
        },
        children: [isLoadingImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoader, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
          style: {
            // need to use visibilty cause with display prop browser is not loadin the image
            visibility: isLoadingImage ? 'hidden' : 'visible',
            height: isLoadingImage ? 0 : '100%'
          },
          imgUrl: (deckImage === null || deckImage === void 0 ? void 0 : deckImage.url) || cabinFallbackBackground,
          alt: "deck plan",
          onLoad: function onLoad() {
            return setIsLoadingImage(false);
          },
          placeholder: cabinFallbackBackground
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/components/molecules/subpage-sticky-bar/subpage-sticky-bar.tsx + 1 modules
var subpage_sticky_bar = __webpack_require__(62217);
// EXTERNAL MODULE: ./src/components/atoms/breadcrumbs/breadcrumbs.tsx
var breadcrumbs = __webpack_require__(86724);
// EXTERNAL MODULE: ./src/components/atoms/breadcrumbs/breadcrumbs.style.tsx
var breadcrumbs_style = __webpack_require__(64221);
// EXTERNAL MODULE: ./src/components/sections/landing-breadcrumbs/landing-breadcrumbs.tsx
var landing_breadcrumbs = __webpack_require__(92885);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./src/hooks/useHandleSearchSubmit.tsx
var useHandleSearchSubmit = __webpack_require__(3354);
;// CONCATENATED MODULE: ./pages/ship/[slug]/cabins-decks.tsx


function cabins_decks_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cabins_decks_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cabins_decks_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cabins_decks_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var ShipCabinPage = function ShipCabinPage(props) {
  var _props$pageProps, _props$pageProps2, _props$pageProps3, _props$pageProps3$get, _ship$description;

  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var modulesData = props === null || props === void 0 ? void 0 : (_props$pageProps = props.pageProps) === null || _props$pageProps === void 0 ? void 0 : _props$pageProps.modulesData;
  var landingPage = props === null || props === void 0 ? void 0 : (_props$pageProps2 = props.pageProps) === null || _props$pageProps2 === void 0 ? void 0 : _props$pageProps2.getLandingPage;
  var meta = props === null || props === void 0 ? void 0 : (_props$pageProps3 = props.pageProps) === null || _props$pageProps3 === void 0 ? void 0 : (_props$pageProps3$get = _props$pageProps3.getLandingPage) === null || _props$pageProps3$get === void 0 ? void 0 : _props$pageProps3$get.meta;
  var breadcrumbsPath = (0,landing_breadcrumbs/* getBreadcrumbsPath */.bp)(landingPage, modulesData, localeConfig);
  var hostUrl = props === null || props === void 0 ? void 0 : props.hostUrl;
  var shipPageUrl = "/".concat(localeConfig.slugs.ship.prefix, "/").concat(landingPage.slug);

  var headTagsData = cabins_decks_objectSpread(cabins_decks_objectSpread({}, meta), {}, {
    hostUrl: hostUrl,
    landingPage: landingPage,
    modulesData: modulesData,
    pageType: 'landingPage'
  });

  var subPageObserverRef = react.useRef(null);
  var handleSubmit = (0,useHandleSearchSubmit/* useHandleSearchSubmit */.r)({
    id: landingPage.id,
    type: landingPage.type,
    title: landingPage.title
  });

  if (!modulesData || !modulesData["ship".concat(landingPage.id)]) {
    return null;
  }

  var ship = modulesData["ship".concat(landingPage.id)];

  if (!ship || !ship.decks) {
    return null;
  }

  var cabinDescription = (ship === null || ship === void 0 ? void 0 : (_ship$description = ship.description) === null || _ship$description === void 0 ? void 0 : _ship$description.cabins) || '';
  var cabinInfoByType = ship.cabinInfoByType;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(head_tags/* HeadTags */.c, cabins_decks_objectSpread({}, headTagsData)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      ref: subPageObserverRef,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(subpage_sticky_bar/* SubpageStickyBar */.j, {
        observerRef: subPageObserverRef,
        shipUrl: shipPageUrl,
        onSearchSubmit: handleSubmit
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinType, {
        headline: "".concat(ship.title, " ").concat((0,translation_service.__)('subpageTitleCabin')),
        description: cabinDescription,
        cabinTypes: cabinInfoByType,
        decks: ship.decks
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
        marginBottom: '140px'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeckPlan, {
        decks: ship.decks,
        title: "".concat((0,translation_service.__)('deckPlan'))
      }, "deckPlan")]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(breadcrumbs_style/* StyledBreadcrumbsContainer */.x, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(breadcrumbs/* Breadcrumbs */.O, {
        paths: breadcrumbsPath
      })
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var cabins_decks = (ShipCabinPage);

/***/ }),

/***/ 18210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Sticky; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
;// CONCATENATED MODULE: ./src/components/hoc/sticky/sticky.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var _ref =  true ? {
  name: "1l675nn",
  styles: "position:static"
} : 0;

var _ref2 =  true ? {
  name: "duudsh",
  styles: "position:fixed"
} : 0;

var StyledSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "elromy90"
} : 0)("top:0;left:0;right:0;z-index:100;", function (props) {
  return props.sticky ? _ref2 : _ref;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/hooks/use-sticky/use-sticky.ts



/**
 * Returns a ref, and a stateful value bound to the ref
 *
 * @param staticRef is the reference of the element's stickiness
 * _Based on that element, it will detect if the element has above or below the `staticRef`_
 */
function useSticky(observerRef) {
  var stickyRef = react.useRef(null);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      sticky = _React$useState2[0],
      setSticky = _React$useState2[1];

  react.useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var ratio = entry.intersectionRatio;
        var boundingRect = entry.boundingClientRect;
        var intersectionRect = entry.intersectionRect;
        var isSticky = ratio < 1 && boundingRect.top < intersectionRect.top;
        var isNotVisibleStickyElement = boundingRect.height === 0 && intersectionRect.height === 0;

        if (ratio === 0 && isNotVisibleStickyElement) {
          setSticky(true);
        }

        if (ratio === 0 && !isSticky) {
          return;
        }

        setSticky(isSticky);
      });
    }, {
      threshold: 1.0
    });

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }
  }, [observerRef]);
  return {
    stickyRef: stickyRef,
    sticky: sticky
  };
}
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/hoc/sticky/sticky.tsx








/**
 * The Sticky component, that is exposing child props and thus can be used from outside
 */
var Sticky = function Sticky(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      loaded = _React$useState2[0],
      setLoaded = _React$useState2[1];

  var _useSticky = useSticky(props.observerRef),
      stickyRef = _useSticky.stickyRef,
      sticky = _useSticky.sticky;

  react.useEffect(function () {
    setLoaded(true);
  }, []);
  var height = typeof props.height === 'number' ? props.height : stickyRef.current ? stickyRef.current.offsetHeight : 0;
  /**
   * `height > 0` - meaning the actual height is declared (the component is initialized)
   *
   * @NOTE ain't gonna work if we have lazy loaded content on wrapped element
   */

  var stickyStyle = height > 0 ? {
    pointerEvents: 'none',
    height: height
  } : null;
  var childrenStyle = {
    pointerEvents: 'all'
  };
  return loaded ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      style: {
        height: sticky ? height : 0
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSticky, {
      ref: stickyRef,
      sticky: sticky,
      style: stickyStyle,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: childrenStyle,
        children: props.children(sticky)
      })
    })]
  }) : props.children(sticky);
};

/***/ }),

/***/ 62217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ SubpageStickyBar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/hoc/sticky/sticky.tsx + 2 modules
var sticky = __webpack_require__(18210);
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device_device = __webpack_require__(90780);
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.style.tsx
var dreamlines_button_style = __webpack_require__(35246);
;// CONCATENATED MODULE: ./src/components/molecules/subpage-sticky-bar/subpage-sticky-bar.style.tsx



var StyledSubpageSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2mde040"
} : 0)("background-color:#ffffff;padding:10px 6px;border-bottom:2px solid ", function (props) {
  return props.theme.colorsUnifications.whiteSmoke[100];
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:16px 0;}.container{display:flex;align-items:center;}", dreamlines_button_style/* StyledButton */.Sn, "{@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding-top:20px;padding-bottom:20px;padding-left:20px;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/components/atoms/back-button/back-button.tsx + 1 modules
var back_button = __webpack_require__(55029);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/subpage-sticky-bar/subpage-sticky-bar.tsx










var SubpageStickyBar = function SubpageStickyBar(props) {
  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var formattedOfferCount = (0,formatting/* replaceVal */.yy)((0,translation_service.__)('seeAllOffers'), '');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sticky/* Sticky */.L, {
    observerRef: props.observerRef,
    children: function children(sticky) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubpageSticky, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: "container",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(back_button/* BackButton */.x, {
            href: props.shipUrl,
            children: (0,translation_service.__)('backToShipOverview')
          }), device !== 'mobile' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
            wrapperStyle: {
              marginLeft: 'auto'
            },
            style: {
              borderRadius: '6px',
              fontWeight: '600'
            },
            onClick: props.onSearchSubmit,
            children: formattedOfferCount
          })]
        })
      });
    }
  });
};

/***/ }),

/***/ 3354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useHandleSearchSubmit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36097);
/* harmony import */ var src_utils_EventTracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6946);



var useHandleSearchSubmit = function useHandleSearchSubmit(_ref) {
  var id = _ref.id,
      type = _ref.type,
      title = _ref.title;
  var localeConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_contexts_locale_config_locale_config__WEBPACK_IMPORTED_MODULE_1__/* .LocaleConfigContext */ .nO);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    if (!type) return;
    window.location.href = "https://www.".concat(localeConfig.url, "/").concat(localeConfig.slugs.search, "?filterParams[").concat(type, "][0]=").concat(id);
    src_utils_EventTracker__WEBPACK_IMPORTED_MODULE_2__/* .eventTracker.track */ .xT.track({
      event: 'click',
      category: 'sticky-bar',
      action: 'search-button',
      label: "".concat(type, "-").concat(title)
    });
  }, [id, type, localeConfig.slugs.search, localeConfig.url]);
};

/***/ }),

/***/ 13557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship/[slug]/cabins-decks",
      function () {
        return __webpack_require__(10836);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4929,8263,6871,8371,9712,9543,2848,847,9774,2888,179], function() { return __webpack_exec__(13557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);